import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Flex, Box } from "@chakra-ui/react";
import PortalHeader from "./PortalHeader";
import PortalSidebar from "./PortalSidebar";
import TrialBanner from "./TrialBanner";
import ExpiredModal from "./ExpiredModal";

const PortalLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleSidebarMouseEnter = () => setIsCollapsed(false);
  const handleSidebarMouseLeave = () => setIsCollapsed(true);

  return (
    <Flex
      direction="column"
      h="100vh"
      pt="54px"
      bgGradient="linear(to-b, #F7FAFD 0%, #EEF4F8 100%)"
    >
      <PortalHeader />
      <TrialBanner />
      <ExpiredModal />
      {/* content below fixed header */}
      <Flex flex="1" minH="0">
        <PortalSidebar
          isCollapsed={isCollapsed}
          onMouseEnter={handleSidebarMouseEnter}
          onMouseLeave={handleSidebarMouseLeave}
        />
        <Box as="main" flex="1" p={6} overflowY="auto" minH="0">
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
};

export default PortalLayout; 